module.exports = __webpack_public_path__ + "static/img/11.d3fb7e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/11.png
// module id = X2nk
// module chunks = 0